import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import ToolsView from '@/views/ToolsTbView.vue'
import ToolsTranslateTemplate from '@/views/ToolsTranslateTemplate.vue'
import FileChat from '@/views/FileChat.vue'
import CycleTaskJob from '@/views/CycleTaskJob.vue'
import ChannelFlowSource from '@/views/ChannelFlowSource.vue'
import DwApiView from '@/views/DwApiView.vue'
import Login from '@/views/Login.vue'
import ToolsCollection from '@/views/ToolsCollection.vue'
import ToolsDoubleVerification from '@/views/ToolsDoubleVerification.vue'
import TbOrderCleanView from '@/views/TbOrderCleanView.vue'
import AuthorizationGuide from '@/views/AuthorizationGuide.vue'
import ChanelC2BTranslate from '@/views/ChanelC2BTranslate.vue'
import { ElMessage } from 'element-plus'
import http from '@/utils/http'
import BurtonDashboard from '@/views/burton/burtonDashboard.vue'
import ExcelPivotTransformView from '@/views/ExcelPivotTransformView.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { isLoginPage: true }
  },
  {
    path: '/template-report',
    name: 'templateReport',
    component: HomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'home',
    component: ToolsCollection,
    meta: { requiresAuth: true }
  },
  {
    path: '/tools-shot-link',
    name: 'tools-shot-link',
    component: ToolsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/tools-translate-template',
    name: 'tools-translate-template',
    component: ToolsTranslateTemplate,
    meta: { requiresAuth: true }
  },
  {
    path: '/file-chat',
    name: 'file-chat',
    component: FileChat,
    meta: { requiresAuth: true }
  },
  {
    path: '/cycle-task-job',
    name: 'cycle-task-job',
    component: CycleTaskJob,
    meta: { requiresAuth: true }
  },
  {
    path: '/channel-flow',
    name: 'channel-flow',
    component: ChannelFlowSource,
    meta: { requiresAuth: true }
  },
  {
    path: '/dw-api',
    name: 'dw-api',
    component: DwApiView,
    meta: { requiresAuth: true }
  },
  {
    path: '/tools-collection',
    name: 'tools-collection',
    component: ToolsCollection,
    meta: { requiresAuth: true }
  },
  {
    path: '/tools-double-verification',
    name: 'tools-double-verification',
    component: ToolsDoubleVerification,
    meta: { requiresAuth: true }
  },
  {
    path: '/tb-order-clean',
    name: 'tb-order-clean',
    component: TbOrderCleanView,
    meta: { requiresAuth: true }
  },
  {
    path: '/tracking-data-query',
    name: 'tracking-data-query',
    component: () => import('@/views/TrackingDataQuery.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/authorization-guide',
    name: 'authorization-guide',
    component: AuthorizationGuide,
    meta: { requiresAuth: true }
  },
  {
    path: '/chanel-c2b-translate',
    name: 'chanel-c2b-translate',
    component: ChanelC2BTranslate,
    meta: { requiresAuth: true }
  },
  {
    path: '/burton-dashboard',
    name: 'burton-dashboard',
    component: BurtonDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/excel-pivot-transform',
    name: 'excel-pivot-transform',
    component: ExcelPivotTransformView,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('auth-token')
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要认证的路由
    if (!token) {
      // 没有token，跳转登录页
      if (to.path === '/') {
        next({ path: '/login', replace: true });
      } else {
        next('/login');
      }
    } else {
      // 有token，需要验证token是否过期
      try {
        const isExpired = await http.isTokenExpired(token);
        if (isExpired) {
          // Token已过期，清除本地数据并跳转登录页
          localStorage.removeItem('auth-token');
          localStorage.removeItem('auth-user');
          ElMessage.error('您的登录已过期，请重新登录');
          if (to.path === '/') {
            next({ path: '/login', replace: true });
          } else {
            next('/login');
          }
        } else {
          // Token有效，继续导航
          next();
        }
      } catch (error) {
        console.error('Token验证失败:', error);
        // Token验证出错，也按过期处理
        localStorage.removeItem('auth-token');
        localStorage.removeItem('auth-user');
        ElMessage.error('认证失败，请重新登录');
        next('/login');
      }
    }
  } else {
    // 不需要认证的路由，直接通过
    next();
  }
})

export default router
